import { render, staticRenderFns } from "./UploadDocsForm.vue?vue&type=template&id=383f9202"
import script from "./UploadDocsForm.vue?vue&type=script&lang=js"
export * from "./UploadDocsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports